<template>
    <a class="nav-online-btn btn"
       data-analytics-id="Menu Modal / Open Task Queue Modal"
       :class="[
           isOnline === true ? `nav-online-btn--online ${onlineClass}` : '',
           isOnline === false ? `nav-online-btn--offline ${offlineClass}` : '',
           queuedTaskCount > 0 ? 'nav-online-btn--with-tasks' : 'nav-online-btn--no-tasks'
       ]"
       @click.prevent="showOnlineStatusModal">
        <template v-if="isOnline === true">
            <i class="fa-solid fa-wifi fa-fw"></i>
            <span class="mobile-only flex--grow flex--shrink text-left">
                {{ l('ONLINE') }}
            </span>
        </template>
        <template v-else-if="isOnline === false">
            <i class="fa-solid fa-wifi-slash fa-fw"></i>
            <span class="mobile-only flex--grow flex--shrink text-left">
                {{ l('OFFLINE') }}
            </span>
        </template>

        <span v-if="queuedTaskCount > 0"
              class="label">{{ queuedTaskCount }}</span>
    </a>
</template>

<script>
import { container } from '@/container';
import { mapState } from 'vuex';
import { MODAL_NAMES } from '@/vue/modals/MODAL_NAMES';

export default {
    name: 'NavOnlineBtn',

    props: {
        onlineClass: {
            type: String,
            default: '',
        },

        offlineClass: {
            type: String,
            default: '',
        },
    },

    computed: {
        ...mapState(['isOnline']),
        ...mapState('onlineQueue', ['queuedTaskCount']),
    },

    methods: {
        showOnlineStatusModal() {
            container.vueModalFactory.openAndIgnoreResult(MODAL_NAMES.ONLINE_STATUS);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../less/variables.less";

.nav-online-btn {
    .badge {
        margin-left: 8px;
        top: 1px;
    }
}

.menu-bar {
    .nav-online-btn {
        min-width: 0 !important;

        i {
            margin: 0 !important;
        }

        &.nav-online-btn--online.nav-online-btn--no-tasks {
            background: none;
            border: none;
        }

        &.nav-online-btn--online {
            i {
                color: @brand-success;
            }
        }

        &.nav-online-btn--offline {
            i {
                color: @brand-danger;
            }
        }
    }
}
</style>
